export interface PolicyAcceptancePayload {
  version: string;
  agreedAt: string;
  locale: string;
  document: string;
  source: string;
}

const POLICY_VERSION = 'v20251111';
const POLICY_EFFECTIVE_DATE = '2025-01-12';

const POLICY_CHANGELOG = [
  {
    version: 'v20251111',
    effectiveDate: '2025-11-11',
    summaryKey: 'legal.metadata.changelog.v20251111'
  },
  {
    version: 'v20250112',
    effectiveDate: '2025-01-12',
    summaryKey: 'legal.metadata.changelog.v20250112'
  }
] as const;

export type PolicyChangeEntry = (typeof POLICY_CHANGELOG)[number];

export const policyMetadata = {
  version: POLICY_VERSION,
  effectiveDate: POLICY_EFFECTIVE_DATE,
  source: 'phototalks-studio',
  documents: {
    terms: '/legal/terms',
    privacy: '/legal/privacy'
  },
  changelog: POLICY_CHANGELOG
} as const;

export function buildPolicyAcceptancePayload(locale: string): PolicyAcceptancePayload {
  return {
    version: policyMetadata.version,
    agreedAt: new Date().toISOString(),
    locale,
    document: 'terms-and-privacy',
    source: policyMetadata.source
  };
}
